// extracted by mini-css-extract-plugin
export default {"cobrand-logo":"logo-component_cobrand-logo__eHDji"};